import React from 'react';
import { Theme } from 'xgimi-ui/theme';
import { SnackbarProvider } from 'notistack';
import Dialog from 'xgimi-ui/Dialog';
import Toast from 'xgimi-ui/Toast';

import { custom as customTheme } from '../../themes';

export default interface State {
  // 主题
  theme: Theme;
  // 消息
  message: React.RefObject<SnackbarProvider>;
  // 对话框
  dialog: React.RefObject<Dialog & HTMLDivElement>;
  // toast
  toast: React.RefObject<Toast & HTMLDivElement>;
}

export const initState: State = {
  theme: customTheme,
  message: React.createRef<SnackbarProvider>(),
  dialog: React.createRef<Dialog & HTMLDivElement>(),
  toast: React.createRef<Toast & HTMLDivElement>(),
};
